import React, { useState, useEffect, useRef, useCallback } from "react";
import { useDispatch } from "react-redux";
import useUnauthorizedHandler from "../../../../../../common/snippet/useUnauthorizedHandler";
import { debounce } from "../../../../../../common/snippet/Debouncing";
import { useSelector } from "react-redux";
import { GetClientProviderIndList } from "../../../../../../actions/Admin-Client/reports/GetClientProviderIndList";
import { GetListOfIndForWorkerInductionReport } from "../../../../../../actions/admin-worker/reports/GetListOfIndForWorkerInductionReport";

function InductionMultiSelectDropdown({
  title,
  updateFilter,
  worker_org_ids,
  //   setInduction_org_ids,
  //     induction_org_ids,
}) {
  const AllFunctions = useSelector((state) => state.allFunctions);
  const [induction_org_ids, setInduction_org_ids] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [items, setItems] = useState([]);
  const [loadData, setLoadData] = useState(true);
  const [checkData, setCheckData] = useState(false);
  const dropdownRef = useRef(null);
  const handleUnauthorizedAccess = useUnauthorizedHandler();
  const dispatch = useDispatch();

  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };

  const handleSeachChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const inputchangeSearch = useCallback(debounce(handleSeachChange), []);
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // const handleSelect = (id) => {
  //   setCheckData(true);
  //   const parsedId = parseInt(id, 10); // Convert string to integer
  //   if (induction_org_ids.includes(parsedId)) {
  //     setInduction_org_ids(
  //       induction_org_ids.filter((itemId) => itemId !== parsedId)
  //     );
  //   } else {
  //     setInduction_org_ids([...induction_org_ids, parsedId]);
  //   }
  // };

  const handleSelect = (item) => {
    setCheckData(true);
    const newEntry = {
      induction_type: item.type,
      induction_id: parseInt(item.id, 10),
    };

    const exists = induction_org_ids.some(
      (entry) => entry.induction_id === newEntry.induction_id
    );

    if (exists) {
      setInduction_org_ids(
        induction_org_ids.filter(
          (entry) => entry.induction_id !== newEntry.induction_id
        )
      );
    } else {
      setInduction_org_ids([...induction_org_ids, newEntry]);
    }
  };
  const clearSelection = () => {
    setCheckData(true);
    setInduction_org_ids([]);
  };

  const GetClientIdData = useCallback(
    async (worker_org_ids) => {
      if (worker_org_ids.length) {
        dispatch(
          GetListOfIndForWorkerInductionReport({
            worker_ids: JSON.stringify(worker_org_ids),
            search: searchTerm,
          })
        ).then((response) => {
          if (response?.success === true) {
            const arrayData = response?.data;
            // setItems(
            //   arrayData?.map((item) => ({
            //     trading_name: item.trading_name,
            //     organisation_id: item.organisation_id,
            //   }))
            // );

            const mergedArray = [
              ...arrayData.siteInductions.map((site) => ({
                type: "site",
                name: site.site_ind_name,
                id: site.site_induction_id,
              })),
              ...arrayData.companyInductions.map((induction) => ({
                type: "companyInduction",
                name: induction.company_ind_name,
                id: induction.company_induction_id,
              })),
            ];
            setItems(mergedArray);
          } else if (response?.status === 401) {
            handleUnauthorizedAccess();
          } else {
            setLoadData(true);
          }
        });
      }
      // eslint-disable-next-line
    },
    [dispatch, searchTerm]
  );

  useEffect(() => {
    GetClientIdData(worker_org_ids);
  }, [searchTerm, worker_org_ids.length]);
  
  useEffect(() => {
    if (checkData) {
      const siteData = induction_org_ids.filter(
        (item) => item.induction_type === "site"
      );
      const companyData = induction_org_ids.filter(
        (item) => item.induction_type === "companyInduction"
      );
      updateFilter("com_ind_ids", companyData);
      updateFilter("site_ind_ids", siteData);
    }
  }, [induction_org_ids]);

  return (
    <div className="relative inline-block text-left w-32" ref={dropdownRef}>
      {/* Dropdown button */}
      <button
        onClick={toggleDropdown}
        disabled={worker_org_ids.length > 0 ? false : true}
        type="button"
        className="flex items-center justify-between w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm text-sm text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-1 focus:ring-blue-500"
      >
        <span>{title}</span>
        {induction_org_ids?.length > 0 && (
          <span className="inline-flex ml-1 items-center justify-center w-6 h-6 text-sm font-semibold text-blue-700 bg-blue-100 rounded-full">
            {induction_org_ids.length}
          </span>
        )}
        <svg
          className="w-5 h-5 ml-2 text-gray-500"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </button>

      {/* Dropdown panel */}
      {isOpen && (
        <div className="absolute left-0 mt-1 w-64 bg-white border border-gray-200 rounded-md shadow-lg z-10">
          {/* Header row: 'X induction_org_ids' and Clear button */}
          <div className="flex items-center justify-between p-2 border-b border-gray-200">
            <span className="text-sm text-gray-500">
              {induction_org_ids.length} selected
            </span>
            <button
              type="button"
              className="text-sm text-blue-600 hover:underline focus:outline-none"
              onClick={clearSelection}
            >
              Clear
            </button>
          </div>

          {/* Search input */}
          <div className="p-2">
            <input
              type="text"
              placeholder="Type here"
              className="w-full px-3 py-2 text-sm border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
              // value={searchTerm}
              onChange={(e) => inputchangeSearch(e)}
            />
          </div>

          {/* Scrollable list of items */}
          <ul className="max-h-48 overflow-y-auto">
            {items?.map((item) => (
              <li
                key={item.organisation_id}
                className="flex items-center px-3 py-2 hover:bg-gray-50"
              >
                <input
                  type="checkbox"
                  className="w-4 h-4 mr-2 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                  // checked={induction_org_ids?.induction_id.includes(parseInt(item.id, 10))}
                  checked={induction_org_ids?.some(
                    (filterItem) =>
                      filterItem.induction_id === parseInt(item.id, 10)
                  )}
                  onChange={() => handleSelect(item)}
                />
                <span className="text-sm text-gray-700">{item.name}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
export default InductionMultiSelectDropdown;
